import { Directive, ElementRef, inject, DestroyRef, afterNextRender, input } from "@angular/core";

@Directive({
    selector: '[fallback]',
    standalone: true
  })
  export class ImageFallbackDirective {
    fallback = input<string|undefined>('/images/fallback/logo.webp');
    element = inject(ElementRef);
    destroy = inject(DestroyRef);

    get actualFallback(): string {
      return this.fallback() ?? '/images/fallback/logo.webp';
    }

    constructor(){
      afterNextRender(() => {
        this.element.nativeElement.addEventListener('error', this.fn, { passive: true });
      });

      this.destroy.onDestroy(() => {
        this.element.nativeElement.removeEventListener('error', this.fn);
      })
    }

    private fn = (event: Event) => this.onError(event);
  
    onError(event: Event){
      if(event && event.target){
        let image = event.target as HTMLImageElement;
        if(!image.src.includes(this.actualFallback))
          image.src = this.actualFallback;
        else {
            image.src = '/images/fallback/logo.png';
            this.element.nativeElement.removeEventListener('error', this.fn);
        }
      }
    }
  }